(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/router/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/components/app/router/assets/javascripts/router.js');
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


const {
  BrowserRouter,
  Link,
  NavLink,
  Prompt,
  Redirect,
  Route,
  Switch,
  generatePath,
  matchPath,
  withRouter
} = ReactRouterDOM;
const {
  HandlePathContainer
} = svs.app.ReactRouter;
const {
  roles
} = svs.core.userSession;
const {
  routesMetaData
} = svs.core.data;
const {
  ErrorBoundary,
  GenericError
} = svs.components.errorBoundary;

const generateRoleRouter = (role, authRedirect) => {
  const RoleRouter = _ref => {
    let {
      basename,
      children,
      render
    } = _ref;
    return React.createElement(ErrorBoundary, {
      renderOnError: GenericError
    }, React.createElement(BrowserRouter, {
      basename: basename
    }, React.createElement(HandlePathContainer, {
      authRedirect: authRedirect,
      render: render,
      role: role,
      routesMetaData: routesMetaData
    }, children)));
  };
  RoleRouter.displayName = "".concat(role, "Router");
  return RoleRouter;
};

Route.propTypes = _objectSpread(_objectSpread({}, Route.propTypes), {}, {
  path: (props, propName) => {
    const path = props[propName];
    if (path && !Array.isArray(path) && !routesMetaData[path]) {
      throw new Error("An exact matching path must be defined in routes metadata, ".concat(path, " could not be found"));
    } else if (path && Array.isArray(path)) {
      path.forEach(currentPath => {
        if (currentPath && !routesMetaData[currentPath]) {
          throw new Error("An exact matching path must be defined in routes metadata, ".concat(currentPath, " could not be found in array"));
        }
      });
    }
  }
});
svs.app.ReactRouter = _objectSpread(_objectSpread({}, svs.app.ReactRouter), {}, {
  PlayerRouter: generateRoleRouter(roles.PLAYER, svs.components.customer_login.login),
  RetailerRouter: generateRoleRouter(roles.RETAILER, window.location.reload),
  InternalRouter: generateRoleRouter(roles.INTERNAL, window.location.reload),
  Link,
  NavLink,
  Prompt,
  Redirect,
  Route,
  Switch,
  generatePath,
  generateRoleRouter,
  matchPath,
  withRouter
});

 })(window);